var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxtoggle"},[_c('iconstoggle',{attrs:{"icons":_vm.icons,"value":_vm.value},on:{"change":function (v) {_vm.value = v}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }